import { render } from "./FileField.vue?vue&type=template&id=4b8b11d2&ts=true"
import script from "./FileField.vue?vue&type=script&lang=ts"
export * from "./FileField.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__